import React, { useEffect } from "react";
import "./Home_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { AllBanner } from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";

function Home_Banner() {

  const dispatch = useDispatch()
  const banner = useSelector((state) => state.common.all_banner);
  useEffect(() => {
    dispatch(AllBanner());
  }, [dispatch]);
  return (
    <>
      <section className="Home_Banner">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          pagination={{ clickable: true }}
          // autoplay={{ delay: 3000 }}
          loop={true}
          className="banner_swiper common_swiper"
        >
          {/* Slide 1 */}
          {banner?.map((data) => (
            <SwiperSlide>
              <div className="img_holder">
                <img src={IDS.IMG_URL + data?.image} alt={data?.name} className="banner_img" />

                <div className="data_div">
                  <p className="data_name">{data?.name}</p>
                  <p className="data_subname">{data?.subname}</p>
                </div>
              </div>

            </SwiperSlide>
          ))}

        </Swiper>
      </section>
    </>
  );
}

export default Home_Banner;